import { getDeviceLocale } from "@cabocheck/shared";
import type { LoaderFunctionArgs } from "react-router";
import { data, useLoaderData } from "react-router";
import { AquireTest } from "~/features/aquire_test/AquireTest";
import { PublicPocProductDetail } from "~/features/poc/PublicPocProductDetail";
import { loadPublicProducts } from "~/utils/apis/loadPublicProducts.server";

export const loader = async ({ params, request }: LoaderFunctionArgs) => {
  const { productGuid } = params;

  if (!productGuid) throw new Response("Not found", { status: 404 });

  const device_locale = getDeviceLocale(request);
  const products = await loadPublicProducts({ device_locale, product_type: "TEST_KIT" });
  const product = products.find((item) => item.product_guid === productGuid);

  if (!product) throw new Response("Not found", { status: 404 });

  return data({ product });
};

export default function PublicPocProductPage() {
  const { product } = useLoaderData<typeof loader>();

  return <PublicPocProductDetail product={product} backFallbackTo="/tests" cta={<AquireTest />} />;
}
